(() => {
  const skipLinkSelector = '.tmenu_skip-link';

  const removeSkipLinks = (root) => {
    if (!(root instanceof Element) && root !== document) return;

    if (root instanceof Element && root.matches(skipLinkSelector)) {
      root.remove();
      return;
    }

    root.querySelectorAll(skipLinkSelector).forEach((skipLink) => skipLink.remove());
  };

  const startSkipLinkRemoval = () => {
    const headerRoot = document.querySelector('.section-header');
    if (!headerRoot) return;

    removeSkipLinks(headerRoot);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => removeSkipLinks(node));
      });
    });

    observer.observe(headerRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSkipLinkRemoval, { once: true });
  } else {
    startSkipLinkRemoval();
  }
})();
